import { JwtInterceptorService } from './services/jwt-interceptor.service';
import { RouterModule } from '@angular/router';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AuthService } from './services/auth.service';
import { SharedModule } from './sharedModule/shared.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule, DatePipe } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { metaReducer, storageMetaReducer } from './store/storage.metareducer';
import { environment } from '../environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
} from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { ErrorInterceptorService } from './error-interceptor.service';
import { MatDialogModule } from '@angular/material/dialog';
// import { TawkService } from './services/tawk.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";

import { BrowserModule } from "@angular/platform-browser";
import { NgxFileDropModule } from 'ngx-file-drop';
import { FormBuilder, FormControl } from '@angular/forms';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ProgressBarComponent } from './sharedModule/report-v2/components/shared/progress-bar/progress-bar.component';
import { MatChipsModule } from '@angular/material/chips';
import { EnvironmentService } from './services/environment.service';
import { AuthSessionComponent } from './auth-session/auth-session.component';
import { SessionService } from './services/session.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [
    AppComponent,
    AuthSessionComponent,
  ],
  imports: [
    BrowserModule,
    RecaptchaModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AppRoutingModule,
    FormsModule,
    MatFormFieldModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    RecaptchaFormsModule,
    MatInputModule,
    MatSelectModule,
    SharedModule,
    HttpClientModule,
    CommonModule,
    RouterModule,
    MatDialogModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    NgxFileDropModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatProgressBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    /**
    You can think of meta-reducers as hooks into the action->reducer pipeline. Meta-reducers allow developers to pre-process actions before normal reducers are invoked.
     */
    StoreModule.forRoot(metaReducer, {
      metaReducers: [storageMetaReducer],
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    StoreDevtoolsModule.instrument({
      name: 'Crossplag',
      maxAge: 25,
      logOnly: environment.production,
    }),
    SocialLoginModule,

  ],
  providers: [
    EnvironmentService,
    AuthService,
    SessionService,
    DatePipe,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '941887313100-70s9pk0dd5ksoi2780jebbjtsovoh3be.apps.googleusercontent.com'
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    {
      // Http error intereptor, to be able to intercept erros we need to add it to the providers in angular module.
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule { }
